<template>
  <div>
    <DeviceListHeader
      :devices="devices"
      :defaultSort="sortKey"
      @add-device="openAddDeviceModal"
      @sorted="sortedDevices = $event"
    />

    <DeviceList
      :devices="sortedDevices"
      :isLoading="isLoading"
      @view="setDeviceForView"
      @edit="setDeviceForEdit"
      @delete="setDeviceForDelete"
    />

    <DeviceModal
      ref="deviceModal"
      :mode="deviceModalMode"
      :device="selectedDevice"
      :templates="templateList"
      @device-added="fetchData"
      @device-edited="fetchData"
    />

    <DeleteDeviceModal
      ref="deleteModal"
      :device="deviceToDelete"
      @deleted="fetchData"
    />

    <BootstrapModal
      ref="viewTemplateModal"
      modalId="viewTemplateModal"
      title="Template"
      closeText="Close"
      hideConfirmButton
    >
      <template #body>
        <div
          class="d-flex justify-content-center align-items-center"
          style="max-height: 70vh"
        >
          <img
            :src="this.adminUrl + (previewTemplate?.setting?.img_screen ?? '')"
            class="img-fluid"
            alt="Template"
          />
        </div>
      </template>
    </BootstrapModal>
  </div>
</template>

<script>
import DeviceModal from "@/components/Device/DeviceModal.vue";
import BootstrapModal from "@/components/Common/BootstrapModal.vue";
import DeleteDeviceModal from "@/components/Device/DeleteDeviceModal.vue";
import DeviceListHeader from "@/components/Device/DeviceListHeader.vue";
import DeviceList from "@/components/Device/DeviceList.vue";
import DeviceService from "@/services/deviceService.js";

export default {
  emits: ["updateTitle"],
  components: {
    BootstrapModal,
    DeleteDeviceModal,
    DeviceList,
    DeviceModal,
    DeviceListHeader,
  },
  data() {
    return {
      sortKey: "id",
      sortedDevices: [],
      adminUrl: process.env.VUE_APP_TEMPLATE_THUMBNAIL_URL,
      isLoading: true,
      devices: [],
      deviceModalMode: 'add',
      selectedDevice: null,
      templateList: [],
      previewTemplate: null,
      deviceToDelete: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    openAddDeviceModal() {
      this.deviceModalMode = 'add';
      this.selectedDevice = null;
      this.$nextTick(() => {
        this.$refs.deviceModal.resetForm();
        this.$refs.deviceModal.show();
      });
    },
    setDeviceForView(device) {
      this.previewTemplate = device;
      this.$refs.viewTemplateModal.show();
    },
    setDeviceForEdit(device) {
      this.deviceModalMode = 'edit';
      this.selectedDevice = device;

      this.$nextTick(() => {
        this.$refs.deviceModal.show();
      });
    },
    setDeviceForDelete(device) {
      this.deviceToDelete = device;
      this.$refs.deleteModal.show();
    },
    async fetchData() {
      try {
        var data = await DeviceService.getDevices();
        this.devices = data.devices;
        this.templateList = data.templates;
      } catch (error) {
        console.error(`Error fetching data.`, error);
      } finally {
        this.isLoading = false;
      }
    },
    async downloadSettings(deviceId) {
      try {
        const response = await DeviceService.downloadSettings(deviceId);
        const blob = new Blob([response.data], { type: "application/gzip" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${deviceId}_sett.tar.gz`;
        link.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download error:", err);
      }
    },
  },
};
</script>
